import { fetchAll } from '@/services/logs.service';

import * as types from './mutation-types';

export default {
  async fetchList({ commit }) {
    commit(types.SET_ERRORS, null);
    try {
      const data = await fetchAll();
      commit(types.SET_LOGS, data);
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  }
};
